<script>
  import { logClickToGA } from "@urbaninstitute/dataviz-components";

  let {
    group_names = ["First group", "Second group"],
    active_name = $bindable("First group"),
    onclick = () => {}
  } = $props();

  function setActive(varname, i, e) {
    active_name = varname;
    onclick();
    // logClickToGA(e.target, "chart-" + chart_number + "-select-click--" + e?.target?.textContent);
    return;
  }
</script>

<div class="container" role="radiogroup">
  {#each group_names as group_name, i}
    <button
      class="tab-group-item"
      tabindex={0}
      role="radio"
      aria-checked={active_name == group_name}
      onclick={(e) => setActive(group_name, i, e)}
    >
      {group_name}
    </button>
  {/each}
</div>

<style>
  .container {
    /* margin-top: var(--spacing-7); */
    flex: 3 1 500px;
    gap: 5px;
    flex-wrap: wrap;
    max-width: 500px;
    min-width: 160px;
    display: flex;
  }
  .tab-group-item {
    height: 45px;
    flex: 1 1 auto;
    appearance: none;
    background: var(--color-gray);
    border: none;
    color: var(--color-black);
    cursor: pointer;
    font-size: var(--font-size-xl);
    line-height: 75%;
    font-family: var(--font-family-sans);
    font-weight: 900;
    padding: var(--spacing-3);

    &:hover:not([aria-checked="true"]) {
      /* background: var(--color-blue-shade-lightest); */
      outline: 2px solid var(--color-gray-shade-dark);
    }
    &:focus-visible {
      outline: 2px solid var(--color-gray-shade-dark);
    }
  }

  .tab-group-item[aria-checked="true"] {
    color: var(--color-white);
    background: var(--color-black);
    cursor: initial;
    &:focus-visible {
      outline: 2px solid var(--color-gray-shade-dark);
    }
  }
</style>
